import React, { useEffect, useMemo } from 'react';
import { Stack, StackItem } from '@patternfly/react-core';
import _ from 'lodash';
import { useQueries } from '@tanstack/react-query';
import createQueryRequest from 'services/createQueryRequest';

import useAPI from 'services/useAPI';
import { useTranslation } from 'localization/useTranslation';
import ModelType from 'components/Model/ModelType';
import ModelsContainer from 'components/Model/ModelsContainer';
import { format } from 'utils/string';
import { modelKeys } from '../../queries';

const SelectBindingStep = ({ migrationInfo, setMigrationInfo, targetBindings, setIsValid }) => {
  const T = useTranslation();
  const api = useAPI();

  const bindings = useQueries({
    queries: _.map(migrationInfo.currentAssetBindingIds, bindingId => {
      const query = { queryKey: modelKeys.binding(bindingId), queryFn: createQueryRequest(api.core.getBinding) };
      return query;
    })
  });

  const bindingModel = useMemo(() => {
    const options = _.map(targetBindings, binding => ({ value: binding, text: binding.displayName, description: binding.id }));
    const mapped = _.map(migrationInfo?.currentAssetBindingIds, (bindingId) => {
      const binding = _.find(bindings, binding => binding?.data?.id === bindingId)?.data;
      return (
        {
          type: ModelType.OPTIONSV2,
          // label: `Map Binding ${binding?.displayName} (${binding?.id})) to`,
          label: format(T.migrate.binding.target, binding?.displayName, binding?.id),
          path: `bindingMap.${bindingId}`,
          isRequired: true,
          hasError: _.isEmpty,
          options: options,
          properties: {
            iteratee: _.iteratee('id'),
            isClearable: true
          }
        });
    });

    return mapped;
  }, [T.migrate.binding.target, bindings, migrationInfo?.currentAssetBindingIds, targetBindings]);

  useEffect(() => {
    setIsValid(!_.isEmpty(migrationInfo?.bindingMap));
  }, [migrationInfo?.bindingMap, setIsValid]);

  return (
    <Stack>
      <StackItem >
        <ModelsContainer models={bindingModel} data={migrationInfo} setData={setMigrationInfo} />
      </StackItem>
    </Stack>
  );
};

export default SelectBindingStep;
